
import Box from 'component/layoutComponents/Box';
import styled from 'styled-components';

export const ListWrapper = styled(Box)(({ theme }) => `
  display: flex;
  flex-direction: column;
  /* gap: ${theme.uptimeSpace[10]}px; */
`);